import { getFormattedUTCDate,currentDateFormat, formatDate, shortDisplayDate24HourWithSec } from "../../utils/displayTime";

// AD @ Single Site
export const ad_single_site_payload = (timePeriod, top_used_site) => {
  let payload = {
    "entry_ts": {
      "start": getFormattedUTCDate(timePeriod[0]),
      "end": getFormattedUTCDate(timePeriod[1])
    },
    "sort": {
      "entry_ts": "asc"
    }
  }
  if(top_used_site) {
    payload["topx_site_usage_flag"] = true;
  }

  return payload;
}

export const ad_single_site_TablePayload = (selectedDate, top_used_site) => {
  let epochStartTime = currentDateFormat(selectedDate)
  let payload = {
    "entry_ts": shortDisplayDate24HourWithSec(formatDate(epochStartTime).utc()),
    "fields": [
         "site_id",
         "site_name",
         "city",
         "display_tunnel_usage",
         "anomaly_rate",
         "app_cnt",
         "impacted_remote_site_cnt",
         "impacted_tunnel_cnt",
         "total_remote_site_cnt",
         "total_tunnel_cnt"
     ],
     "sort": {anomaly_rate: "desc"}
  }
  if(top_used_site) {
    payload["topx_site_usage_flag"] = true;
  }
  return payload
}

export const getSiteAttr = (selectedDate, site_id) => {
  let epochStartTime = currentDateFormat(selectedDate)
  let payload = {
    "entry_ts": shortDisplayDate24HourWithSec(formatDate(epochStartTime).utc()),
    "site_id": site_id,
    "fields": ["city", "site_name"]
  }
  return payload
}

export const ad_ss_heatmap_payload = (timePeriod, site_id) => {
  const payload = {
    "entry_ts": {
       "start": getFormattedUTCDate(timePeriod[0]),
       "end": getFormattedUTCDate(timePeriod[1])
    },
    "site_id": site_id,
    "fields": [
        "anomaly_rate",
        "entry_ts"
    ],
    "sort": {entry_ts: "desc"}
  }
  return payload;
}

export const getSsHourlyPayload = (timePeriod, site_id) => {
  let payload = {
    "entry_ts": shortDisplayDate24HourWithSec(formatDate(timePeriod).utc()),
    "site_id": site_id,
    "fields": [
       "remote_site_id",
       "remote_site_city",
       "remote_site_name",
       "circuit_name",
       "local_service_provider",
       "remote_service_provider",
       "tunnel_name",
       "display_app_usage",
       "app_cnt",
       "anomaly_rate"
    ],
    "sort": {anomaly_rate: "desc"}
  }

  return payload
}

export const getTunnelHmPayload = (timePeriod, tunnel_name) => {
  let payload = {
    "entry_ts": {
      "start": getFormattedUTCDate(timePeriod[0]),
      "end": getFormattedUTCDate(timePeriod[1])
    },
    tunnel_name: tunnel_name,
    fields: [
       "anomaly_rate",
       "entry_ts",
       "display_app_usage",
       "app_cnt"
    ],
    "sort": {entry_ts: "desc"}
  }

  return payload
}

export const getTrendChartsPayload = (timePeriod, tunnel_name) => {
  let payload = {
    "entry_ts": {
      "start": getFormattedUTCDate(timePeriod[0]),
      "end": getFormattedUTCDate(timePeriod[1])
    },
    "tunnel_name": tunnel_name,
    "fields": [
      "entry_ts",
      "app_usage",
      "display_app_usage",
      "loss_percentage",
      "loss_percentage_anomaly",
      "daily_loss_percentage_mean",
      "daily_loss_percentage_std_dev",
      "daily_sla_classes_static_baseline_loss_percentage",
      "latency",
      "latency_anomaly",
      "daily_latency_mean",
      "daily_latency_std_dev",
      "daily_sla_classes_static_baseline_latency",
      "jitter",
      "jitter_anomaly",
      "daily_jitter_mean",
      "daily_jitter_std_dev",
      "daily_sla_classes_static_baseline_jitter"
    ],
    "sort": {
      "entry_ts": "asc"
    }
  }
  return payload;
}

// Usage Based AD
export const getcircuitUsagePayload = (timePeriod) => {
  let payload = {
    "entry_ts": {
      "start": getFormattedUTCDate(timePeriod[0]),
      "end": getFormattedUTCDate(timePeriod[1])
    },
    "fields": ["cellular_usage","display_cellular_usage", "entry_ts", "cellular_anomalous_circuit_cnt", "perc_anomalous_cellular_circuits", "cellular_circuit_cnt"],
    "sort": {
      "entry_ts": "asc"
    }
  }
  return payload;
}

export const ad_circuit_summary_TablePayload = (timePeriod) => {
  let payload = {
  "entry_ts": shortDisplayDate24HourWithSec(formatDate(timePeriod).utc()),
  "is_link_cellular": true,
  "sort": {
    "circuit_usage": "desc"
  },
  "size": 25
  }
  return payload;
}

export const getCiuPayload = (timePeriod, circuit_name) => {
  let payload = {
    "entry_ts": {
      "start": getFormattedUTCDate(timePeriod[0]),
      "end": getFormattedUTCDate(timePeriod[1])
    },
    "fields": [
      "entry_ts",
      "circuit_name",
      "circuit_usage",
      "display_circuit_usage",
      "ensemble_baseline",
      "display_ensemble_baseline",
      "anomaly_flag",
      "display_circuit_name",
      "device_host_name"
    ],
    "circuit_name": circuit_name,
    "sort": {
      "entry_ts": "asc"
    }
  }
  return payload;
}

export const availPayload = (timePeriod, site) => {
  let payload = {
    "entry_ts": shortDisplayDate24HourWithSec(formatDate(timePeriod).utc()),
    "site_id": site,
    "sort": {
      "availability": "asc"
    },
    "offset": 0,
    "size": 10
    }
  return payload;
}

export const nwAvailHmPayload = (timePeriod, circuits) => {
  let payload ={
    "entry_ts": {
      "start": getFormattedUTCDate(timePeriod[0]),
      "end": getFormattedUTCDate(timePeriod[1])
    }, 
    circuit_name: circuits,
    sort: { circuit_display_name: "asc", entry_ts: "asc" }
  }
  return payload;
}

export const applicationsPayload = (circuit_name, timePeriod) => {
  let payload = {
    "time_frame":"7d",
    "entry_ts": shortDisplayDate24HourWithSec(formatDate(timePeriod).utc()),
    "circuit_name": circuit_name,
    "sort":{"entry_ts":"asc"}
  }
  
  return payload;
}

export const appChartPayload = (circuit_name, applist, timePeriod) => {
  let payload = {
    "entry_ts": {
      "start": getFormattedUTCDate(timePeriod[0]),
      "end": getFormattedUTCDate(timePeriod[1])
    },
    "circuit_name": circuit_name,
    "application": applist,
    "sort": {"entry_ts":"asc"}
  }
  return payload;
}

export const adTopClientsPayload = (circuitName, timePeriod) => {
  let payload = {
    "time_frame": "7d",
    "entry_ts": shortDisplayDate24HourWithSec(formatDate(timePeriod).utc()),
    "circuit_name": circuitName,
    "sort": {
      "usage": "desc"
    },
    "size": 10
  }

  return payload;
}